import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function PageTracker() {
  const { pathname, search } = useLocation();
  const last = useRef(null);
  useEffect(() => {
    if (last.current === pathname) return;
    last.current = pathname;
    const utm = new URLSearchParams(search).get("utm_source") || "";
    const body = JSON.stringify({ path: pathname, ref: document.referrer || "", w: window.innerWidth, utm_source: utm });
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/hit`, { method: "POST", headers: { "Content-Type": "application/json" }, body, credentials: "include", keepalive: true }).catch(() => {});
  }, [pathname, search]);
  useEffect(() => {
    const ping = () => { if (document.visibilityState !== "visible") return; fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/ping`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ path: window.location.pathname }), credentials: "include", keepalive: true }).catch(() => {}); };
    ping();
    const t = setInterval(ping, 60000);
    document.addEventListener("visibilitychange", ping);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", ping); };
  }, []);
  return null;
}
